export default function LocalAuthority() {
  const associations = [
    { name: 'Better Business Bureau', logo: 'ri-award-line' },
    { name: "Angie's List", logo: 'ri-star-line' },
    { name: 'HomeAdvisor', logo: 'ri-home-smile-line' },
    { name: 'Houzz', logo: 'ri-building-line' },
    { name: 'NALP Member', logo: 'ri-plant-line' }
  ];

  return (
    <section className="py-24 bg-[#FFF8F0]">
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="text-center mb-12">
          <div className="text-[#E67E22] text-xs font-semibold tracking-[0.2em] uppercase mb-4">
            GLEN MILLS' TRUSTED LANDSCAPER
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-8">Deeply Rooted in Our Community</h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 mb-16">
          <div>
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              For over 15 years, ScapeWorx has been the go-to landscaping contractor for homeowners throughout Glen Mills and Delaware County. Our deep understanding of local soil conditions, climate challenges, and architectural styles ensures every project is perfectly suited to our region.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              As a locally owned business, we take pride in contributing to our community's beauty and supporting local suppliers and craftsmen. When you choose ScapeWorx, you're choosing a neighbor who cares about your property as much as you do.
            </p>
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <i className="ri-map-pin-fill text-[#E67E22] text-xl"></i>
                <span className="font-semibold text-gray-900">Serving Delaware County since 2009</span>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-team-fill text-[#E67E22] text-xl"></i>
                <span className="font-semibold text-gray-900">Local team of certified professionals</span>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-hand-heart-fill text-[#E67E22] text-xl"></i>
                <span className="font-semibold text-gray-900">Active community involvement</span>
              </div>
            </div>
          </div>

          <div className="relative rounded-2xl overflow-hidden shadow-2xl h-[400px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d98304.85!2d-75.4719!3d39.8561!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c6f8f8f8f8f8f8%3A0x0!2sGlen%20Mills%2C%20PA!5e0!3m2!1sen!2sus!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="ScapeWorx service area map"
            ></iframe>
            <div className="absolute bottom-6 left-6 right-6 bg-white rounded-xl p-6 shadow-xl">
              <div className="flex items-start gap-4">
                <i className="ri-map-pin-2-fill text-3xl text-[#E67E22]"></i>
                <div>
                  <div className="font-bold text-gray-900 mb-1">ScapeWorx Headquarters</div>
                  <div className="text-sm text-gray-600 mb-2">Glen Mills, PA 19342</div>
                  <a href="tel:6105550123" className="text-[#E67E22] font-semibold text-sm hover:underline cursor-pointer whitespace-nowrap">
                    (610) 555-0123
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-300 pt-12">
          <div className="text-center mb-8">
            <h3 className="text-xl font-bold text-gray-900 mb-2">Trusted & Certified</h3>
            <p className="text-gray-600">Proud members and affiliates</p>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-12">
            {associations.map((assoc, index) => (
              <div key={index} className="flex flex-col items-center gap-3 grayscale hover:grayscale-0 transition-all opacity-60 hover:opacity-100">
                <div className="w-16 h-16 flex items-center justify-center">
                  <i className={`${assoc.logo} text-5xl text-gray-700`}></i>
                </div>
                <span className="text-sm font-semibold text-gray-700 whitespace-nowrap">{assoc.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}